export const checklists = state => state.checklists.items

export const checklistById = state => id => _.find(checklists(state), {id})

export const checklistsByReference = state =>(reference_type, reference_id) => {
    reference_id = parseInt(reference_id)
    return _.filter(checklists(state), {reference_type, reference_id})
}